import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "outer-bg"
};
const _hoisted_2 = {
  class: "center-wrap"
};
const _hoisted_3 = {
  class: "week"
};
const _hoisted_4 = {
  class: "week-title"
};
const _hoisted_5 = {
  class: "table"
};
const _hoisted_6 = {
  class: "th"
};
const _hoisted_7 = {
  class: "tds"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "food"
};
const _hoisted_10 = {
  key: 0,
  class: "item"
};
const _hoisted_11 = {
  class: "food"
};
const _hoisted_12 = {
  class: "thali thali-module"
};
const _hoisted_13 = {
  class: "meal"
};
const _hoisted_14 = {
  class: "date"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "food"
};
const _hoisted_17 = {
  class: "food-center"
};
const _hoisted_18 = {
  class: "img-list"
};
const _hoisted_19 = {
  class: "rate-list"
};
const _hoisted_20 = {
  class: "label"
};
const _hoisted_21 = {
  class: "info"
};
const _hoisted_22 = {
  class: "energy"
};
import { ref, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useBigScreen } from '@/hooks/useBigScreen.js';
import { v4 } from 'uuid';
import { weeklyLabelPreview, nutritionLabelWeekly } from '@/api/index';
// import HeaderTitle from './components/Title.vue';
import nullImg from '@/assets/images/screen-null.png';
export default {
  __name: 'preview',
  setup(__props) {
    let route = useRoute();
    let screen = ref();
    let unitId = ref('');
    onMounted(() => {
      useBigScreen(screen);
      unitId.value = route.query?.id;
      getWeeklyLabel();
      getNewWeekly('init');
    });
    // 判断是否更新
    let updateInfo = reactive({
      id: '',
      modifyTime: ''
    });
    // API 获取周食谱标签
    let weekTitle = ref('');
    let typeList = ref([]);
    let weekList = ref([]);
    let textWeek = ['一', '二', '三', '四', '五', '六', '日'];
    let colorList = reactive(['#31ded8', '#efda1e', '#f6a429', '#6fe881', '#1fb4ff']);
    let autoplayTag = ref(false);
    let bannerImageList = ref([]);
    let layoutType = ref('');
    let carousel = ref(null);
    function getWeeklyLabel() {
      carousel.value?.next();
      weeklyLabelPreview(unitId.value).then(data => {
        layoutType.value = data?.layoutType;
        let bannerList = [];
        // 封面图
        let coverList = data?.coverImageList || [];
        bannerImageList.value = coverList.map(item => {
          return {
            id: item.id,
            url: item.url
          };
        });
        let tip = data?.week ? `第${data?.week}周` : '';
        weekTitle.value = data?.weeklyMenuLabelName || '';
        weekTitle.value = tip ? weekTitle.value + `(${tip})` : '';
        let dataList = data?.weeklyMenuListLabelList || [];
        weekList.value = dataList.map((item, index) => {
          let currentList = item?.weeklyMenuEverydayLabelList || [];
          let children = currentList.map(day => {
            let date = day?.date?.substring(5, 10);
            let notWeek = true;
            typeList.value.forEach(item => {
              if (item.dayOfWeek == day.dayOfWeek) {
                notWeek = false;
              }
            });
            if (notWeek) {
              typeList.value.push({
                name: `星期${textWeek[day.dayOfWeek - 1]}（${date}）`,
                dayOfWeek: day.dayOfWeek
              });
            }
            // 套餐：不需要展示成分，需要套餐名称与组成套餐菜名
            let setList = day?.setMealList.map(ite => {
              let combination = ite?.recipeList?.map(recipe => {
                return recipe?.name;
              });
              return {
                id: ite?.id,
                name: ite?.name,
                foodList: combination.join('、')
              };
            });
            // 菜谱：菜谱显示组成成分
            let recipeName = day?.recipeList?.reduce((prev, cur) => {
              let partList = [];
              if ([13, 14, 15].includes(layoutType.value)) {
                partList = cur.foodCompositionList.map(pt => {
                  return `${pt.name} ${pt.dosage}g`;
                });
              }
              // 成分拼接到名字上
              let curName = cur.name;
              if (partList.length > 0) {
                curName += `【${partList.join('、')}】`;
              }
              return prev ? `${prev}、${curName}` : `${curName}`;
            }, '');

            // 套餐轮播图 bannerList
            // 1、全部菜单合并展示：12、15、22
            let dateFormate = date.split('-');
            if ([12, 15, 22].includes(layoutType.value)) {
              // 套餐
              if (day?.setMealList?.length > 0) {
                day?.setMealList.forEach(xitem => {
                  let subname = '';
                  let dosageList = [];
                  let imgList = [];
                  xitem.recipeList.forEach(cur => {
                    subname = subname ? `${subname}、${cur.name}` : cur.name;
                    let dosageInfo = cur.foodCompositionList.reduce((prev, cur1) => {
                      return prev ? `${prev}、${cur1.name}${cur1.dosage}g` : `${cur1.name}${cur1.dosage}g`;
                    }, '');
                    dosageList.push({
                      name: cur.name,
                      dosage: `【${dosageInfo}】`
                    });
                    if (imgList.length < 3 && cur?.coverImage?.url) {
                      imgList.push(cur.coverImage.url);
                    }
                  });
                  let recipeNutritionList = [];
                  xitem?.recipeNutritionList.forEach((pro, index) => {
                    pro['proportion'] = +(pro.proportion * 100).toFixed(2);
                    pro['proportionRate'] = pro['proportion'] > 100 ? 100 : pro['proportion'];
                    pro['bgColor'] = colorList[index];
                    index <= 4 && recipeNutritionList.push(pro);
                  });
                  imgList = imgList.length == 0 ? [nullImg] : imgList;
                  let obj = {
                    id: xitem?.id,
                    meal: item?.mealTimes?.name,
                    type: 'thali',
                    name: xitem.name,
                    subname,
                    dateTxt: getDateTxt(day, textWeek, dateFormate),
                    recipeNutritionList,
                    dosageList,
                    urlList: imgList
                  };
                  bannerList.push(obj);
                });
              }
              // 菜谱
              if (day?.recipeList?.length > 0) {
                let urlList = [];
                let subname = '';
                let dosageList = [];
                day.recipeList.forEach(xct => {
                  if (xct?.coverImage?.url && urlList.length < 3) {
                    urlList.push(xct.coverImage.url);
                  }
                  subname = subname ? `${subname}、${xct.name}` : xct.name;
                  let dosage = xct.foodCompositionList.reduce((prev, cur) => {
                    return prev ? `${prev}、${cur.name}${cur.dosage}g` : `${cur.name}${cur.dosage}g`;
                  }, '');
                  let coobcook = {
                    name: xct.name,
                    dosage: `【${dosage}】`
                  };
                  dosageList.push(coobcook);
                });
                let recipeNutritionList = [];
                day?.recipeNutritionList.forEach((pro, index) => {
                  pro['proportion'] = +(pro.proportion * 100).toFixed(2);
                  pro['proportionRate'] = pro['proportion'] > 100 ? 100 : pro['proportion'];
                  pro['bgColor'] = colorList[index];
                  index <= 4 && recipeNutritionList.push(pro);
                });
                urlList = urlList.length == 0 ? [nullImg] : urlList;
                let obj = {
                  id: v4(),
                  meal: item?.mealTimes?.name,
                  type: 'cookbook',
                  name: '菜单',
                  subname,
                  dateTxt: getDateTxt(day, textWeek, dateFormate),
                  urlList,
                  recipeNutritionList,
                  dosageList
                };
                bannerList.push(obj);
              }
            }
            // 2、当日菜单合并展示：10、13、20
            else if (data.today === day?.date && [10, 13, 20].includes(layoutType.value)) {
              // 套餐
              if (day?.setMealList?.length > 0) {
                day?.setMealList.forEach(xitem => {
                  let subname = '';
                  let dosageList = [];
                  let imgList = [];
                  xitem.recipeList.forEach(cur => {
                    subname = subname ? `${subname}、${cur.name}` : cur.name;
                    let dosageInfo = cur.foodCompositionList.reduce((prev, cur1) => {
                      return prev ? `${prev}、${cur1.name}${cur1.dosage}g` : `${cur1.name}${cur1.dosage}g`;
                    }, '');
                    dosageList.push({
                      name: cur.name,
                      dosage: `【${dosageInfo}】`
                    });
                    if (imgList.length < 3 && cur?.coverImage?.url) {
                      imgList.push(cur.coverImage.url);
                    }
                  });
                  let recipeNutritionList = [];
                  xitem?.recipeNutritionList.forEach((pro, index) => {
                    pro['proportion'] = +(pro.proportion * 100).toFixed(2);
                    pro['proportionRate'] = pro['proportion'] > 100 ? 100 : pro['proportion'];
                    pro['bgColor'] = colorList[index];
                    index <= 4 && recipeNutritionList.push(pro);
                  });
                  imgList = imgList.length == 0 ? [nullImg] : imgList;
                  let obj = {
                    id: xitem?.id,
                    meal: item?.mealTimes?.name,
                    type: 'thali',
                    name: xitem.name,
                    subname,
                    recipeNutritionList,
                    dosageList,
                    urlList: imgList,
                    dateTxt: getDateTxt(day, textWeek, dateFormate)
                  };
                  bannerList.push(obj);
                });
              }
              // 菜谱
              if (day?.recipeList?.length > 0) {
                let urlList = [];
                let subname = '';
                let dosageList = [];
                day.recipeList.forEach(xct => {
                  if (xct?.coverImage?.url && urlList.length < 3) {
                    urlList.push(xct.coverImage.url);
                  }
                  subname = subname ? `${subname}、${xct.name}` : xct.name;
                  let dosage = xct.foodCompositionList.reduce((prev, cur) => {
                    return prev ? `${prev}、${cur.name}${cur.dosage}g` : `${cur.name}${cur.dosage}g`;
                  }, '');
                  let coobcook = {
                    name: xct.name,
                    dosage: `【${dosage}】`
                  };
                  dosageList.push(coobcook);
                });
                let recipeNutritionList = [];
                day?.recipeNutritionList.forEach((pro, index) => {
                  pro['proportion'] = +(pro.proportion * 100).toFixed(2);
                  pro['proportionRate'] = pro['proportion'] > 100 ? 100 : pro['proportion'];
                  pro['bgColor'] = colorList[index];
                  index <= 4 && recipeNutritionList.push(pro);
                });
                urlList = urlList.length == 0 ? [nullImg] : urlList;
                let obj = {
                  id: v4(),
                  meal: item?.mealTimes?.name,
                  type: 'cookbook',
                  name: '菜单',
                  subname,
                  urlList,
                  recipeNutritionList,
                  dosageList,
                  dateTxt: getDateTxt(day, textWeek, dateFormate)
                };
                bannerList.push(obj);
              }
            }
            // 3、当日菜单分开展示：11、14、21
            else if (data.today === day?.date && [11, 14, 21].includes(layoutType.value)) {
              // 套餐
              if (day?.setMealList?.length > 0) {
                day?.setMealList.forEach(xitem => {
                  let subname = '';
                  let dosageList = [];
                  let imgList = [];
                  xitem.recipeList.forEach(cur => {
                    subname = subname ? `${subname}、${cur.name}` : cur.name;
                    let dosageInfo = cur.foodCompositionList.reduce((prev, cur1) => {
                      return prev ? `${prev}、${cur1.name}${cur1.dosage}g` : `${cur1.name}${cur1.dosage}g`;
                    }, '');
                    dosageList.push({
                      name: cur.name,
                      dosage: `【${dosageInfo}】`
                    });
                    if (imgList.length < 3 && cur?.coverImage?.url) {
                      imgList.push(cur.coverImage.url);
                    }
                  });
                  let recipeNutritionList = [];
                  xitem?.recipeNutritionList.forEach((pro, index) => {
                    pro['proportion'] = +(pro.proportion * 100).toFixed(2);
                    pro['proportionRate'] = pro['proportion'] > 100 ? 100 : pro['proportion'];
                    pro['bgColor'] = colorList[index];
                    index <= 4 && recipeNutritionList.push(pro);
                  });
                  imgList = imgList.length == 0 ? [nullImg] : imgList;
                  let obj = {
                    id: xitem?.id,
                    meal: item?.mealTimes?.name,
                    type: 'thali',
                    name: xitem.name,
                    subname,
                    recipeNutritionList,
                    dosageList,
                    urlList: imgList,
                    dateTxt: getDateTxt(day, textWeek, dateFormate)
                  };
                  bannerList.push(obj);
                });
              }
              // 菜谱
              if (day?.recipeList?.length > 0) {
                day.recipeList.forEach(xct => {
                  let dosageList = [];
                  let urlList = [];
                  let subname = '';
                  if (xct?.coverImage?.url) {
                    urlList.push(xct.coverImage.url);
                  }
                  let newDosage = xct.foodCompositionList.reduce((prev, cur) => {
                    return prev ? `${prev}、${cur.name}${cur.dosage}g` : `${cur.name}${cur.dosage}g`;
                  }, '');
                  let coobcook = {
                    name: '',
                    dosage: newDosage
                  };
                  dosageList.push(coobcook);
                  let recipeNutritionList = [];
                  xct?.recipeNutritionList.forEach((pro, index) => {
                    pro['proportion'] = +(pro.proportion * 100).toFixed(2);
                    pro['proportionRate'] = pro['proportion'] > 100 ? 100 : pro['proportion'];
                    pro['bgColor'] = colorList[index];
                    index <= 4 && recipeNutritionList.push(pro);
                  });
                  urlList = urlList.length == 0 ? [nullImg] : urlList;
                  let obj = {
                    id: v4(),
                    meal: item?.mealTimes?.name,
                    type: 'cookbook',
                    name: xct.name,
                    subname,
                    urlList,
                    recipeNutritionList,
                    dosageList,
                    dateTxt: getDateTxt(day, textWeek, dateFormate)
                  };
                  bannerList.push(obj);
                });
              }
            }
            return {
              date,
              fullDate: day?.date,
              dayOfWeek: day.dayOfWeek,
              setMealList: setList,
              recipeList: recipeName
            };
          });
          let colorIndex = index > 2 ? index : index % 3;
          return {
            name: item?.mealTimes?.name,
            bgColor: colorList[colorIndex],
            children
          };
        });
        getBannerList(bannerList, 3);
        getBannerTitle(data.today);
        autoplayTag.value = true;
      });
    }
    /**
     * 生成日期文本
     * @param {Object} day
     * @param {Array} textWeek
     * @param {Array} dateFormate
     * @returns {string}
     */
    function getDateTxt(day, textWeek, dateFormate) {
      return `星期${textWeek[day.dayOfWeek - 1]}（${dateFormate[0]}月${dateFormate[1]}日）`;
    }
    // 判断最后一张索引
    function getBannerLastIndex(current) {
      let allIndex = 0;
      if (layoutType.value == 10) {
        allIndex = bannerImageList.value.length + bannerDataList.value.length - 1 + 1;
      } else {
        allIndex = bannerImageList.value.length + bannerDataList.value.length - 1;
      }
      if (current == allIndex && allIndex > 0) {
        autoplayTag.value = false;
        setTimeout(() => {
          getNewWeekly();
        }, 8000);
      }
    }
    // 获取banner数据
    let bannerDataList = ref([]);
    function getBannerList(arr, groupSize) {
      bannerDataList.value = arr.reduce((acc, _, index) => {
        if (index % groupSize === 0) {
          acc.push(arr.slice(index, index + groupSize));
        }
        return acc;
      }, []);
    }
    // 获取轮播标题
    let bannerTitle = ref('');
    let weekDay = ref(['日', '一', '二', '三', '四', '五', '六']);
    function getBannerTitle(dateStr) {
      let myDate = new Date(dateStr);
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let today = myDate.getDay();
      bannerTitle.value = `星期${weekDay.value[today]}（${month}月${day}日）`;
    }
    // API 判断是否有新数据
    function getNewWeekly(type) {
      nutritionLabelWeekly(unitId.value).then(data => {
        if (type) {
          updateInfo.id = data?.id;
          updateInfo.modifyTime = data?.modifyTime;
          return;
        }
        if (data?.id != updateInfo.id || data?.modifyTime != updateInfo.modifyTime) {
          // 新数据
          getWeeklyLabel();
          updateInfo.id = data?.id;
          updateInfo.modifyTime = data?.modifyTime;
        } else {
          carousel.value?.next();
          autoplayTag.value = true;
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "page",
        ref_key: "screen",
        ref: screen
      }, [_createVNode(_component_el_carousel, {
        height: "100%",
        ref_key: "carousel",
        ref: carousel,
        "indicator-position": "none",
        interval: 10000,
        "motion-blur": "",
        arrow: "never",
        autoplay: _unref(autoplayTag),
        "pause-on-hover": false,
        onChange: getBannerLastIndex
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bannerImageList), item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item.id
          }, {
            default: _withCtx(() => [_createVNode(_component_el_image, {
              class: "cover-img",
              fit: "contain",
              src: item.url
            }, null, 8, ["src"])]),
            _: 2
          }, 1024);
        }), 128)), [10, 11, 12, 13, 14, 15].includes(_unref(layoutType)) ? (_openBlock(), _createBlock(_component_el_carousel_item, {
          key: 0
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(weekTitle)), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), item => {
            return _openBlock(), _createElementBlock("div", {
              class: "td",
              key: item.dayOfWeek
            }, _toDisplayString(item.name), 1);
          }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekList), (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "row",
              key: index
            }, [_createElementVNode("div", {
              class: "row-name",
              style: _normalizeStyle({
                backgroundColor: item.bgColor
              })
            }, _toDisplayString(item.name), 5), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, rw => {
              return _openBlock(), _createElementBlock("div", {
                class: "td",
                key: rw.date
              }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rw.setMealList, ite => {
                return _openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: ite.id
                }, [_createElementVNode("div", _hoisted_8, _toDisplayString(ite.name), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(ite.foodList), 1)]);
              }), 128)), rw.recipeList ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[0] || (_cache[0] = _createElementVNode("div", {
                class: "title"
              }, " 菜单 ", -1)), _createElementVNode("div", _hoisted_11, _toDisplayString(rw.recipeList), 1)])) : _createCommentVNode("", true)]);
            }), 128))])]);
          }), 128))])])])]),
          _: 1
        })) : _createCommentVNode("", true), _unref(bannerDataList).length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(_unref(bannerDataList), (item, index) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, ite => {
              return _openBlock(), _createElementBlock("div", {
                class: "thali-item",
                key: ite.id
              }, [_createElementVNode("div", _hoisted_13, _toDisplayString(ite.meal), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(ite.dateTxt), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(ite.name), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ite.dosageList, (itt, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: "food-item",
                  key: index
                }, [_createElementVNode("span", null, _toDisplayString(itt.name), 1), _createTextVNode(" " + _toDisplayString(itt.dosage), 1)]);
              }), 128))])]), _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ite.urlList, url => {
                return _openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: url
                }, [_createVNode(_component_el_image, {
                  src: url,
                  fit: "cover"
                }, null, 8, ["src"])]);
              }), 128))]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ite.recipeNutritionList, (pro, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: index
                }, [_createElementVNode("div", _hoisted_20, _toDisplayString(pro.name), 1), _createVNode(_component_el_progress, {
                  "text-inside": true,
                  "stroke-width": 48,
                  percentage: pro.proportionRate,
                  "show-text": false,
                  color: pro.bgColor
                }, null, 8, ["percentage", "color"]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", null, _toDisplayString(pro.proportion) + "%", 1), _createElementVNode("div", _hoisted_22, _toDisplayString(pro.value) + _toDisplayString(pro.unit), 1)])]);
              }), 128))])]);
            }), 128))])]),
            _: 2
          }, 1024);
        }), 128)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["autoplay"])], 512)]);
    };
  }
};